import Header from "../navigation/header";
import Footer from "../navigation/footer";
import { Users, BookOpen, LayoutDashboard } from "lucide-react";

import { Layout, Menu } from "antd";
import {
    DashboardOutlined, BookOutlined, UserOutlined, MenuFoldOutlined,
    MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";

const { Sider, Content } = Layout;

const navItems = [
    { key: "overview", icon: <LayoutDashboard size={24} />, label: "Overview" },
    { key: "courses", icon: <BookOpen size={24} />, label: "Courses" },
    { key: "users", icon: <Users size={24} />, label: "Users" },
];
const matchPaths = {
    courses: ["courses", "create-course", "view-course"],
    users: ["users"],
    overview: ["overview"],
};

function AdminLayout() {

    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);

    const selectedKey =
        Object.keys(matchPaths).find((key) =>
            matchPaths[key].some((path) => location.pathname.includes(path))
        ) || "overview";


    return (
        <>
            <Header />

            <Layout style={{ minHeight: "100vh" }}>
                <Sider
                    className="admin-sider"
                    collapsible

                    collapsed={collapsed}
                    trigger={collapsed ? <MenuUnfoldOutlined style={{ color: "#fff" }} /> : <MenuFoldOutlined style={{ color: "#fff" }} />}

                    onCollapse={setCollapsed}
                    breakpoint="lg"
                    collapsedWidth={0} // fully hides on mobile instead of squishing
                >

                    <Menu
                        className="admin-menu"
                        theme="dark"
                        mode="inline"
                        selectedKeys={[selectedKey]}
                        items={navItems}
                        onClick={({ key }) => navigate(key)}
                    />
                </Sider>

                <Layout>
                    <Content style={{ margin: "24px 16px", padding: 24, background: "#f5f5f5" }}>
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>

        </>

    )
}

export default AdminLayout